module.exports = __webpack_public_path__ + "img/Teenies.ec11473f.jpg";